import styles from "./ContactList.module.css";
import PropTypes from "prop-types";
import { ContactListItem } from "./ContactListItem/ContactListItem";

export function ContactList({
  contacts,
  selectedContactId,
  getContactPath,
  onContactClick,
}) {
  return (
    <ul className={styles.contactList}>
      {contacts.map((record, i) => (
        <li key={i}>
          <ContactListItem
            contact={record}
            isSelected={record.id == selectedContactId}
            getContactPath={getContactPath}
            onContactClick={onContactClick}
          />
        </li>
      ))}
    </ul>
  );
}

ContactList.propTypes = {
  /**
   * A list of contact records.
   */
  contacts: PropTypes.arrayOf(ContactListItem.propTypes.contact).isRequired,

  /**
   * ID of the currently loaded contact.
   */
  selectedContactId: PropTypes.string,

  /**
   * Function that takes a contact record and returns a path to navigate to it.
   */
  getContactPath: PropTypes.func,

  /**
   * Callback that runs when a contact in the list is clicked.
   * Receives click event and the contact details as arguments.
   */
  onContactClick: PropTypes.func,
};
